import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { usePode } from '@/api/me';
import { configuracoesPermitidas } from '@/components/app-shell/navegacao';

/** /configuracoes: manda para a primeira aba que o usuario pode abrir (Empresa, depois Usuarios e acessos). */
export const Route = createFileRoute('/_app/configuracoes/')({
  component: ConfiguracoesIndex,
});

function ConfiguracoesIndex() {
  const navigate = useNavigate();
  const { pode, carregando } = usePode();
  const primeira = configuracoesPermitidas(pode)[0];
  const destino = primeira?.rota;

  useEffect(() => {
    if (destino) void navigate({ to: destino, replace: true });
  }, [destino, navigate]);

  if (carregando) return <p role="status" className="px-5 py-10 text-center text-small text-ink-muted">Carregando configurações…</p>;
  return destino ? null : <p role="status" className="px-5 py-10 text-center text-small text-ink-muted">Sem acesso</p>;
}
